// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity-image{display:block}.entity-image__content{width:100%;height:100%;border-radius:4px}.entity-image__content--circle{border-radius:100%;box-shadow:#0000003b 0 0 10px;-webkit-box-shadow:0 0 10px 0 #0000003b}", ""]);
// Exports
module.exports = exports;
